<template>
    <div class="page-content">
        <div class="page-body">
            <div class="page-body-top">
                <img class="top-img" src="./../assets/img/detailB.jpg" alt="">
                <div class="top-content">
                    <img v-if="detail.user.portrait" class="user-head" :src="`/api/v1/file/${detail.user.portrait}`" alt="">
                    <div class="mr-a">
                        <div class="f-18 fw-b mb-6">{{detail.user.nickname}}</div>
                        <div class="f-14 color-grays">{{detail.user.city}} 注册时间：{{detail.user.created_at}}</div>
                    </div>
                    <el-popover
                            placement="bottom-start"
                            title="分享"
                            width="200"
                            trigger="hover">
                        <div slot="reference" class="title-right">
                            <i class="el-icon-share"></i>
                            分享
                        </div>
                        <div data-sites="qzone, qq, weibo, wechat" class="social-share"></div>
                    </el-popover>
                </div>
            </div>
            <div class="content-body">
                <div class="content-title">个人介绍</div>
                <div class="content-text" v-html="newBio||'暂无介绍~'"></div>
                <div v-if="newBio" class="color-grays f-14 mt-10 mb-10 tran-content">
                    是否使用谷歌翻译
                    <template v-if="!traning">
                        <el-link class="ml-20" type="primary" @click="trans('zh')">翻译为中文</el-link>
                        <el-link class="ml-10" type="primary" @click="trans('jp')">翻译为日文</el-link>
                    </template>
                    <el-link v-else class="ml-10" type="primary">翻译中...</el-link>
                </div>
                <div class="content-text" v-for="(item,index) in transList" :key="index">{{item.dst}}</div>

                <div class="content-title">精通语言</div>
                <div class="content-text">{{detail.user.language}}</div>

                <div class="content-title">家乡</div>
                <div class="content-text">{{detail.user.country}} {{detail.user.city}}</div>
            </div>
            <div class="content-body" style="padding-left: 0;padding-right: 0;">
                <div class="content-title ml-30">精品路线</div>
                <div class="card-content" style="width: 100%;">
                    <LineCard v-for="(item,index) in detail.tourist" :key="index" :item="item"></LineCard>
                </div>
            </div>
            <div class="content-body">
                <div class="content-title">车辆介绍</div>
                <div class="car-item" v-for="(item,index) in detail.car" :key="index">
                    <el-form style="flex: 1" label-position="right" label-width="100px">
                        <el-form-item style="margin-bottom: 0;" label="车辆名称：">{{item.name}}</el-form-item>
                        <el-form-item style="margin-bottom: 0;" label="车辆座位：">{{item.seats}}座</el-form-item>
                        <el-form-item style="margin-bottom: 0;" label="接送区间：">{{item.section1}}</el-form-item>
                        <el-form-item style="margin-bottom: 0;" label="接送机场：">{{item.section2}}</el-form-item>
                        <el-form-item style="margin-bottom: 0;" label="每车价格：">
                            <span class="color-red f-18">{{+item.price|parseMoney}}</span>
                        </el-form-item>
                    </el-form>
                    <el-carousel class="gallery-top">
                        <el-carousel-item class="gallery-top" v-for="(it,index) in item.image" :key="index">
                            <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                                <img class="swiper-img" :preview="`shuttle${item.id}`" :src="`/api/v1/file/${it}`" alt="">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LineCard from "../components/LineCard";
    export default {
        name: "driverDetail",
        components:{LineCard},
        data() {
            return {
                traning: false,
                transList: [],
                user_id: '',
                detail:{
                    user: {},
                    tourist: [],
                    car: []
                },
                config: {
                    title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: '', // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat']
                }
            }
        },
        mounted() {
            this.user_id = this.$route.query.id;
            this.carEngine();
        },
        computed:{
            newBio(){
                if(this.detail.user.bio){
                    return this.detail.user.bio.replace(/\n/g, '<br/>')
                }
                return ''
            }
        },
        methods: {
            async trans(to) {
                this.traning = true;
                let [e, data] = await this.$api.transApi({to, q: this.detail.user.bio})
                this.traning = false;
                this.transList = data.result;
            },
            async carEngine() {
                let [e, data] = await this.$api.carEngineApi({user_id: this.user_id})
                this.detail = data.result;
                socialShare('.social-share', this.config)
            }
        },
    }
</script>

<style scoped lang="less">
    .page-content{
        padding: 20px;
    }
    .page-body{
        width: 900px;
        box-shadow: 3px 3px 6px #A6A6A6;
        margin: auto;
        background-color: #ffffff;
    }
    .page-body-top{
        width: 100%;
        border-bottom: 1px solid #e2e2e2;
        .top-img{
            width: 100%;
            height: 118px;
            object-fit: cover;
        }
        .top-content{
            width: 100%;
            padding-left: 160px;
            padding-right: 20px;
            padding-bottom: 20px;
            height: 80px;
            box-sizing: border-box;
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .user-head{
                position: absolute;
                width: 100px;
                height: 100px;
                border-radius: 100%;
                left: 0;
                bottom: 0;
                transform: translate(30px, -20px);
                object-fit: cover;
            }
        }
    }
    .content-body {
        padding: 10px 30px 30px 30px;
        box-sizing: border-box;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #e2e2e2;
    }
    .content-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }

    .content-text {
        font-size: 14px;
        line-height: 2;
    }
    .car-item{
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        height: 240px;
        border-bottom: 1px solid #e2e2e2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:last-child{
            border-bottom: none;
        }
        .gallery-top{
            flex: 1;
            height: 100%;
            .swiper-img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
</style>
